import * as loaderNames from '../consts/loader/loaderNames';
import {hideLoader, showLoader} from '../state/ducks/global';
import {dispatch} from '../state/store';
import helpers from '../utils/helpers';

let instance = null;

export default class PairingHandlerService {
    constructor() {
        if (instance) {
            return instance;
        }

        instance = this;
        this.handler = null;
    }

    setPairingHandler(handler) {
        this.handler = handler;
        dispatch(hideLoader(loaderNames.PAIRING_IN_PROGRESS_LOADER));
    }

    removePairingHandler() {
        this.pairingIsStopped();
        this.handler = null;
    }

    pairingIsStarted(loaderName = loaderNames.PAIRING_IN_PROGRESS_LOADER) {
        if (this.handler) {
            helpers.runFunction(this.handler, {isStart: true});
        } else {
            dispatch(showLoader(loaderName));
        }
    }

    pairingIsStopped(loaderName = loaderNames.PAIRING_IN_PROGRESS_LOADER) {
        dispatch(hideLoader(loaderName));
        if (this.handler) {
            helpers.runFunction(this.handler, {isStart: false});
        }
    }
}
